// Hook centralisant les listes personnalisées de l'utilisateur : la liste
// des listes (id/nom/nombre de cartes) + les actions create/rename/delete
// et l'ajout de cartes depuis n'importe quelle vue. Calqué sur useCollection.js.

import { useState, useCallback, useEffect } from "react";
import {
  fetchLists, createList, renameList, deleteList, addItemsToList, setListPrivacy,
} from "../lib/api";

export function useCustomLists() {
  const [lists, setLists] = useState([]);

  const reloadLists = useCallback(async () => {
    try { setLists(await fetchLists()); }
    catch (err) { console.error(err); }
  }, []);

  useEffect(() => { reloadLists(); }, [reloadLists]);

  const addList = useCallback(async (name) => {
    try {
      const created = await createList(name);
      setLists(prev => [...prev, created]);
      return created;
    } catch (err) { console.error(err); return null; }
  }, []);

  const updateListName = useCallback(async (listId, name) => {
    try {
      await renameList(listId, name);
      setLists(prev => prev.map(l => l.id === listId ? { ...l, name } : l));
    } catch (err) { console.error(err); }
  }, []);

  const removeList = useCallback(async (listId) => {
    try {
      await deleteList(listId);
      setLists(prev => prev.filter(l => l.id !== listId));
    } catch (err) { console.error(err); }
  }, []);

  // Utilisé depuis les autres vues (SetDetailView, GlobalBrowseView, ...)
  // pour ajouter une sélection de cartes à une liste existante — recharge
  // juste le compteur, pas besoin de connaître le contenu ici.
  const addToList = useCallback(async (listId, items) => {
    if (!items || items.length === 0) return;
    try {
      await addItemsToList(listId, items);
      reloadLists();
    } catch (err) { console.error(err); }
  }, [reloadLists]);

  const updateListPrivacy = useCallback(async (listId, isPrivate) => {
    try {
      await setListPrivacy(listId, isPrivate);
      setLists(prev => prev.map(l => l.id === listId ? { ...l, private: isPrivate } : l));
    } catch (err) { console.error(err); }
  }, []);

  return { lists, reloadLists, addList, updateListName, removeList, addToList, updateListPrivacy };
}
